import React from 'react';
import { Link } from 'react-router-dom';
import { currentTenant } from '../tenant/tenants';

interface LogoLinkProps {
  className?: string;
  imgClassName?: string;
  height?: number;
}

const LogoLink: React.FC<LogoLinkProps> = ({ className, imgClassName, height = 115.2 }) => {
  const { logo, logoAlt, logoHeightScale } = currentTenant.brand;
  return (
    <Link to="/" className={className} aria-label="Home">
      <img
        src={logo}
        alt={logoAlt}
        className={imgClassName}
        style={logoHeightScale === 1
          ? { height, width: 'auto' }
          : { height: height * logoHeightScale, width: 'auto', maxWidth: '100%', objectFit: 'contain' }}
        onError={(e) => {
          const target = e.currentTarget as HTMLImageElement;
          target.onerror = null;
          target.src = '/logo192.png';
        }}
      />
    </Link>
  );
};

export default LogoLink;


